<template>
  <div class="legal-page">
    <div class="legal-container">
      <div class="breadcrumb-bar">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="sep">/</span>
        <span class="crumb-current">企业资质</span>
      </div>

      <section class="legal-section">
        <h2>营业执照</h2>
        <div class="cert-wrapper">
          <div class="cert-card">
            <div class="cert-img" :style="certStyle">
              <img src="../../assets/news/zhizhao.jpg" alt="" class="cert-img" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "license",
  data() {
    return {
      certStyle: {
        background: "#fafbfc",
      },
    };
  },
  mounted() {
    document.title = "企业资质-辰鳗科技集团-小鳗管家";
  },
};
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 0 80px;
}
.legal-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px 60px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.breadcrumb-bar {
  font-size: 14px;
  color: #969fa6;
  margin-bottom: 24px;
}
.crumb {
  cursor: pointer;
  color: #3170ff;
}
.crumb:hover {
  text-decoration: underline;
}
.sep {
  margin: 0 8px;
  color: #c0c4cc;
}
.crumb-current {
  color: #606266;
}
.legal-title {
  font-size: 28px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 8px;
  text-align: center;
}
.legal-updated {
  text-align: center;
  color: #969fa6;
  font-size: 13px;
  margin-bottom: 40px;
}
.legal-section {
  margin-bottom: 32px;
}
.legal-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 16px;
  padding-left: 12px;
  border-left: 3px solid #3170ff;
}
.legal-section p,
.legal-section li {
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
}
.legal-section a {
  color: #3170ff;
  text-decoration: none;
}
.legal-section a:hover {
  text-decoration: underline;
}
.info-list {
  list-style: none;
  padding: 0;
  background: #fafbfc;
  border-radius: 8px;
  padding: 16px 24px;
}
.info-list li {
  padding: 8px 0;
  border-bottom: 1px dashed #e4e7ed;
}
.info-list li:last-child {
  border-bottom: none;
}
.info-list .label {
  color: #23262a;
  font-weight: 500;
  margin-right: 8px;
}
.cert-wrapper {
  display: flex;
  justify-content: center;
}
.cert-card {
  text-align: center;
}
.cert-img {
  width: 100%;
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  color: #c0c4cc;
  font-size: 16px;
}
.cert-tip {
  margin-top: 16px;
  font-size: 13px;
  color: #969fa6;
}
.honor-list {
  padding-left: 24px;
  columns: 2;
  column-gap: 40px;
}
.honor-list li {
  margin-bottom: 6px;
}
.legal-footer {
  text-align: center;
  color: #969fa6;
  font-size: 13px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}
@media (max-width: 768px) {
  .legal-container {
    padding: 24px 20px;
  }
  .legal-title {
    font-size: 22px;
  }
  .honor-list {
    columns: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/license.vue